import React, { Component } from 'react';

import { CardList } from './component/card-list/card-list.component'; 
import { SearchBox } from './component/search-box/search-box.component'; 

import './App.css';

//var typepage_load="https://choisirmongroupement.com/json_groupements.php";
//var typepage_title="Annuaire des groupements de pharmacies";
//export var typepage_rech="groupement";
//var typepage_load="https://choisirmongroupement.com/json_generiqueurs.php";
//var typepage_title="Annuaire des génériqueurs";
//export var typepage_rech="génériqueur";
//var typepage_load="https://choisirmongroupement.com/json_grossistes.php";
//var typepage_title="Annuaire des grossistes répartiteurs";
//export var typepage_rech="grossiste répartiteur";
//var typepage_load="https://choisirmongroupement.com/json_centrale.php";
//var typepage_title="Annuaire des centrales d'achat";
//export var typepage_rech="centrale d'achat";
//var typepage_load="https://choisirmongroupement.com/json_transactionnaire.php";
//var typepage_title="Annuaire des transactionnaires d'officine";
//export var typepage_rech="un transactionnaire";
//var typepage_load="https://choisirmongroupement.com/json_agenceur.php";
//var typepage_title="Annuaire des agenceurs";
//var typepage_load="https://choisirmongroupement.com/json_booster.php";
//var typepage_title="Annuaire des boosters d'apport";
//var typepage_load="https://choisirmongroupement.com/json_lgo.php";
//var typepage_title="Annuaire des LGO";
//export var typepage_rech="un LGO";
//var typepage_load="https://choisirmongroupement.com/json_agenceweb.php";
//var typepage_title="Annuaire des agences Web de la pharma";
//export var typepage_rech="une agence web";
//var typepage_load="https://choisirmongroupement.com/json_robots.php";
//var typepage_title="Annuaire des robots de pharmacie";
//export var typepage_rech="un robot";
var typepage_load="https://choisirmongroupement.com/json_compta.php";
//var typepage_title="Annuaire des experts comptables du secteur de la pharmacie";
export var typepage_rech="un expert comptable";
class App extends Component {
  constructor() {
    super();
    this.state = {
      grp: [],
      searchField: '' 
    };
  }

  componentDidMount() {
    
    fetch(typepage_load)
    .then(response => response.json())
    .then(users => this.setState({grp : users}))
  }

  handleChange = e => {
    this.setState({ searchField: e.target.value });
  }

  render () {
    const { grp, searchField } = this.state;
    const filtered = grp.filter(grp => grp.name.toLowerCase().includes(searchField.toLowerCase()))

    return (
      <div className="App">
      <div className="App-title">{/*typepage_title*/}</div>
      <div className="Recherche">
      <SearchBox placeholder={"Rechercher " + typepage_rech} handleChange={this.handleChange}/>
      </div>
      <CardList grp={filtered} />
      </div>
    );
  }
}

export default App;
